<template>
<div>
    <h3 class="text-center" style="text-transform: uppercase">Hóa đơn tiền phòng</h3>
    <table class="mx-auto">
        <tr>
            <td
                colspan="2"
                class="text-left text-no-wrap font-weight-bold"
                style="width: 200px"
            >
                Tháng {{ bill.month }}
            </td>
        </tr>
        <tr>
            <td
                class="text-left text-no-wrap font-weight-bold"
                style="width: 200px;"
            >
                {{ bill.name }}
            </td>
            <td class="text-right text-no-wrap font-weight-bold" style="width: 200px">
                {{ bill.room_id }}
            </td>
        </tr>
        <!-- <tr>
            <td
                class="text-left text-no-wrap font-weight-bold"
                style="width: 200px"
            >
                Số người ở
            </td>
            <td class="text-right text-no-wrap" style="width: 200px">
                {{ bill.customers.length }} người
            </td>
        </tr> -->
        <tr>
            <td class="font-weight-bold" colspan="2">Tiền điện</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">
                {{ bill.electric_price | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu tháng</td>
            <td class="text-right text-no-wrap">
                {{ bill.electric.start | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối tháng</td>
            <td class="text-right text-no-wrap">
                {{ bill.electric.end | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">
                {{
                    (bill.electric.end - bill.electric.start)
                        | formatNumber
                }}
            </td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">
                {{ bill.electric.total_bill | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền nước
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">
                {{ bill.water_price | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu tháng</td>
            <td class="text-right text-no-wrap">
                {{ bill.water.start | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối tháng</td>
            <td class="text-right text-no-wrap">
                {{ bill.water.end | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">
                {{ (bill.water.end - bill.water.start) | formatNumber }}
            </td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">
                {{ bill.water.total_bill | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="font-weight-bold">
                Tiền nhà
            </td>
            <td class="text-right">
                {{ bill.room_bill | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="font-weight-bold">
                Tiền rác và vệ sinh
            </td>
            <td class="text-right text-no-wrap">
                {{ bill.trash_bill | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="font-weight-bold">
                Tiền Internet
            </td>
            <td class="text-right text-no-wrap">
                {{ bill.internet.total_bill | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="font-weight-bold">
                Tiền xe
            </td>
            <td class="text-right text-no-wrap">
                {{
                    (bill.motorbike.total_bill + bill.bike.total_bill)
                        | formatNumber
                }}
            </td>
        </tr>
        <tr>
            <td class="font-weight-bold">Số ngày</td>
            <td class="text-right">{{ bill.date_count | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">
                Tiền máy giặt
            </td>
            <td class="text-right text-no-wrap">
                {{ bill.washing_machine.total_bill | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="font-weight-bold">
                Tiền máy lạnh
            </td>
            <td class="text-right text-no-wrap">
                {{ bill.air_conditioner.total_bill | formatNumber }}
            </td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left">TỔNG CỘNG</td>
            <td class="text-right">
                {{ bill.total_bill | formatNumber }}
            </td>
        </tr>
        <tr>
            <td colspan="2">BIDV (Nguyen Thi Gam): 31210000374258</td>
        </tr>
        <tr>
            <td colspan="2">VCB (Nguyen Thi Gam): 0181003531061</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">Gọi 0835990179 gặp Hương để phản ánh</td>
        </tr>
    </table>
    <!-- <table class="mx-auto">
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Số phòng</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.room_id }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Thời gian</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.month }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Họ tên</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.name }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Số người ở</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.customers.length }} người</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Ngày hẹn vào ở</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.date_schedule_in | formatTimeServer }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Ngày vào ở</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.date_in | formatTimeServer }}</td>
        </tr>
        <tr></tr>
        <tr></tr>
        <tr class="font-weight-black">
            <td class="text-left">TỔNG CỘNG</td>
            <td class="text-right">{{ bill.total_bill | formatNumber}} VND</td>
        </tr>
        <tr v-if="bill.csv_data">
            <td class="text-left">Excel</td>
            <td class="text-right">{{ bill.csv_data.total_bill | formatNumber}} VND</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền điện</u>
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">{{ bill.electric_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.electric.start | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.electric.end | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">{{ (bill.electric.end - bill.electric.start) | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.electric.total_bill | formatNumber }}</td>
        </tr>
        <tr v-if="bill.csv_data">
            <td class="text-left text-no-wrap">Excel</td>
            <td class="text-right text-no-wrap">{{ bill.csv_data.electric_total_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền nước</u>
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">{{ bill.water_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.water.start | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.water.end | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">{{ (bill.water.end - bill.water.start) | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.water.total_bill | formatNumber }}</td>
        </tr>
        <tr v-if="bill.csv_data">
            <td class="text-left text-no-wrap">Excel</td>
            <td class="text-right text-no-wrap">{{ bill.csv_data.water_total_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền phòng</u>
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá</td>
            <td class="text-right">{{ bill.room_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left">-- Số ngày</td>
            <td class="text-right">{{ bill.date_count | formatNumber }} {{ bill.csv_data ? '(' + bill.csv_data.date_count + ')' : '' }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.room_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.room_bill)  + ')' : '' }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền rác và vệ sinh</u>
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá</td>
            <td class="text-right">{{ bill.trash_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left">-- Số ngày</td>
            <td class="text-right">{{ bill.service_date_count | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.trash_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.trash_total_bill) + ')' : '' }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền xe</u>
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá xe máy</td>
            <td class="text-right">{{ bill.motorbike_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá xe đạp</td>
            <td class="text-right">{{ bill.bike_price | formatNumber }}</td>
        </tr>
        <tr
            v-for="(device, index) in bill.motorbike.data"
            :key="index"
        >
            <td class="text-left">-- {{ device.name }}</td>
            <td class="text-right">{{ device.date_count }} ngày</td>
        </tr>
        <tr
            v-for="(device, index) in bill.bike.data"
            :key="index"
        >
            <td class="text-left">-- {{ device.name + (index + 1) }}</td>
            <td class="text-right">{{ device.date_count }} ngày</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.motorbike.total_bill + bill.bike.total_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.bike_motorbike_total_bill) + ')' : '' }}</td>
        </tr>
        <template v-if="bill.washing_machine && bill.washing_machine.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    <hr>
                    <u>Tiền máy giặt</u>
                </td>
            </tr>
            <tr>
                <td class="text-left">Đơn giá</td>
                <td class="text-right">{{ bill.washing_machine_price | formatNumber }}</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.washing_machine.total_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.washing_machine_total_bill) + ')' : '' }}</td>
            </tr>
        </template>
        <template v-if="bill.air_conditioner && bill.air_conditioner.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    <hr>
                    <u>Tiền máy lạnh</u>
                </td>
            </tr>
            <tr>
                <td class="text-left">Đơn giá</td>
                <td class="text-right">{{ bill.air_conditioner_price | formatNumber }}</td>
            </tr>
            <tr>
                <td class="text-left">Số ngày</td>
                <td class="text-right">{{ bill.air_conditioner.data[0].date_count }}</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.air_conditioner.total_bill | formatNumber }}</td>
            </tr>
        </template>
        <template v-if="bill.internet && bill.internet.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    <hr>
                    <u>Tiền Internet</u>
                </td>
            </tr>
            <tr
                v-for="(device, index) in bill.internet.data"
                :key="index"
            >
                <td class="text-left">-- {{ device.name }} ({{ device.price / 1000}}k)</td>
                <td class="text-right">{{ device.date_count }} ngày</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.internet.total_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.internet_total_bill) + ')' : '' }}</td>
            </tr>
        </template>
        <tr>
            <td colspan="2">BIDV (Nguyen Thi Gam): 31210000374258</td>
        </tr>
        <tr>
            <td colspan="2">VCB (Nguyen Thi Gam): 0181003531061</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">Gọi 0835990179 gặp Hương để phản ánh</td>
        </tr>
    </table> -->
</div>
</template>
<script>
export default {
    props: {
        bill: Object
    },
    name: "room-bill-detail",
    data(){
        return {}
    },
    methods: {
        formatNumber(x){
            return x ? x.toLocaleString('vi-VI') : 0
        }
    }
}
</script>